import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    moduleId: module.id,
    templateUrl: 'home.component.html'
})
export class HomeComponent implements OnDestroy {


    constructor(
        private _router: Router) {


    }

    ngOnDestroy(): void {
        Object.keys(this).map(k => {
            this[k] = null;
        });
    }

    editorClick(): void {
       this._router.navigate(['list']);
    }

    playerClick(): void {
        this._router.navigate(['listplay']);
     }


}


// WEBPACK FOOTER //
// ./src/app/pages/home/home.component.ts